import React, { useState, useEffect } from 'react'
import { loadModelStrategies } from '../../../actions/data'
import i18n from '../../../i18n.js'
import './ModelList.css'
import ModelRow from './ModelRow'
import ModelSelect from './ModelSelect'
import TickerSelection from '../TickerSelection/TickerSelection'
import { useSelector, useDispatch } from 'react-redux'
import ReactPaginate from 'react-paginate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Spinner } from '../Components/Spinner'

const ModelList = () => {
  const [currPage, setCurrPage] = useState(0)
  const NUM_PER_PAGE = 5

  const paginate = ({ selected }) => {
    setCurrPage(selected)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadModelStrategies())
  }, [dispatch])

  const strategies = useSelector(state => state.data.modelStrategies)

  const min = currPage * NUM_PER_PAGE
  const max = min + NUM_PER_PAGE

  if (strategies && strategies.length > 0) {
    const sortedStrategies = [...strategies].sort((a, b) => a.name.localeCompare(b.name))
    const strategiesToList = sortedStrategies.slice(min, max)
    const pageCount = Math.ceil(sortedStrategies.length / NUM_PER_PAGE)
    // Sort strategies by name in ascending order

    return (
      <div className='strategyModelList'>
        <div className='row'>
          <div className='selectCopy col-sm-12'>{i18n.t('select-model')}</div>
          <div className='selectBenchmark col-sm-12'>
            {i18n.t('default-benchmark-select')}
          </div>
        </div>
        <ModelSelect strategiesToList={strategies} />
        <TickerSelection />
        <div className='headers'>
          <div className='menu title'>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{i18n.t('name')}
          </div>
          <div className='inception title'>{'Inception Date'}</div>
        </div>

        {strategiesToList.map((strategy, index) => {
          return (
            <ModelRow
              modelStrategy={strategy}
              key={strategy.id}
              striped={index % 2 !== 0}
            />
          )
        })}
        <ReactPaginate
          previousLabel={<FontAwesomeIcon icon='chevron-left' size='xs' />}
          nextLabel={<FontAwesomeIcon icon='chevron-right' size='xs' />}
          pageCount={pageCount}
          marginPagesDisplayed={pageCount}
          pageRangeDisplayed={pageCount}
          onPageChange={paginate}
          containerClassName={'pagination'}
          pageClassName={'page-item'}
          pageLinkClassName={'page-item'}
          previousClassName={'page-item'}
          previousLinkClassName={'pageLink'}
          nextClassName={'page-item'}
          nextLinkClassName={'pageLink'}
          activeClassName={'active'}
          disabledClassName={'disabled'}
        />
      </div>
    )
  }

  return <Spinner />
}

export default ModelList
